import carrierallComponent from './carrier.all.component';
let carrierallModule = angular.module('carrierall', [
])

.component('carrierall', carrierallComponent)

.name;

export default carrierallModule;


// WEBPACK FOOTER //
// ./client/app/components/carrier/all/index.js